module.exports = __webpack_public_path__ + "img/background.942a259a.png";